import clsx from 'clsx'
import React, { FC, ReactElement } from 'react'

import { FormElementProps } from '@Components/FormElements/FormElementProps'
import css from '@Components/FormElements/index.styl'

export interface BaseFormInputProps extends FormElementProps {
  children: ReactElement
  formActive: boolean
}

export const BaseFormInput: FC<BaseFormInputProps> = (
  {
    adornments,
    children,
    error,
    formActive,
    id,
    label,
    size = 'medium',
    variant = 'outlined',
    withoutLabelAnimation = false,
    wrapperClassName,
  }: BaseFormInputProps,
) => (
  <div
    className={clsx(
      adornments?.start && css.FormElementsWithStartAdornment,
      adornments?.end && css.FormElementsWithEndAdornment,
      css.FormElement,
      size !== 'small' && !withoutLabelAnimation && css.FormElementWithLabelAnimation,
      size === 'small' && css.FormElementSizeSmall,
      size === 'medium' && css.FormElementSizeMedium,
      variant === 'outlined' && css.FormElementVariantOutlined,
      variant === 'underlined' && css.FormElementVariantUnderlined,
      wrapperClassName,
    )}
  >
    <div
      className={clsx(
        css.FormElementInner,
        formActive && css.FormActive,
      )}
    >
      {size !== 'small' && !withoutLabelAnimation && <label htmlFor={id}>{label}</label>}
      {adornments?.start && <div className={css.StartAdornment}>{adornments.start}</div>}
      {adornments?.end && <div className={css.EndAdornment}>{adornments.end}</div>}
      {children}
    </div>
    {error && <span className={css.ErrorMessage}>{error}</span>}
  </div>
)
